import { Button, Divider, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, TmdxAvatar } from '@ds';

type ConfirmDetachModalProps = {
  isOpen: boolean;
  isPending: boolean;
  onOpenChange: () => void;
  name: string;
  photo: string;
  onSubmit: () => void;
};

export const ConfirmDetachModal = ({
  isOpen,
  isPending,
  onOpenChange,
  name,
  photo,
  onSubmit,
}: ConfirmDetachModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      size="xl"
      onOpenChange={onOpenChange}
      scrollBehavior="inside"
      hideCloseButton
      classNames={{
        header: 'text-hl! text-base-10 font-secondary flex flex-col gap-1 bg-base-80 rounded-2xl',
        body: 'bg-base-80 py-4',
        footer: 'bg-base-80 py-3 rounded-2xl',
      }}
    >
      <ModalContent>
        <ModalHeader>
          Detach Resource?
          <Divider />
        </ModalHeader>
        <ModalBody>
          <div className="flex gap-2 items-center">
            <div className="text-l-r">Are you sure you want to detach resource</div>
            <TmdxAvatar size="sm" src={photo} />
            <div className="text-m-m">{name?.trim() || 'Unnamed Contact'} ?</div>
          </div>
        </ModalBody>
        <ModalFooter className="flex flex-col">
          <Divider />
          <div className="flex gap-3 py-3">
            <Button disabled={isPending} className="h-9 flex-1" variant="outline" onPress={onOpenChange}>
              Discard
            </Button>
            <Button className="h-9 flex-1" isLoading={isPending} variant="solid" onPress={onSubmit}>
              Detach from Case
            </Button>
          </div>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
